import React, { useContext, useEffect, useState } from "react";
import styles from "./style.module.scss";

import { getCompletedService } from "../../helpers/getCompletedService";
import { MainContext } from "../../context/MainContext";
import getWorkingDays from "../../helpers/getWorkingDays";

function ServiceIndicators() {
  const { markers } = useContext(MainContext);
  const [count, setCount] = useState({});

  const workingDays = getWorkingDays();

  useEffect(() => {
    const result = getCompletedService(markers);
    setCount(result);
  }, [markers]);

  const resultPercentOut = 100 - count?.completionPercentage;

  return (
    <div className={styles.service_indicators}>
      <div className={styles.service_indicator}>
        <p className={styles.service_indicator_title}>сегодня</p>
        <div className={styles.service_icon_green}>{count?.currentDay?.count}</div>
        <p>Выполненые ТО</p>
      </div>
      <div className={styles.service_indicator}>
        <p className={styles.service_indicator_title}>месяц</p>
        <div className={styles.service_icon_green}>
          {count?.currentMonth?.count} / {count?.completionPercentage}%
        </div>
        <p>Выплненые ТО %</p>
      </div>
      <div className={styles.service_indicator}>
        <div className={styles.service_icon_yellow}>
          {count?.remainingCount} / {resultPercentOut.toFixed(1)}%
        </div>
        <p>Оставшиеся ТО</p>
      </div>
      <div className={styles.service_indicator}>
        <div className={styles.service_icon_yellow}>{workingDays}</div>
        <p>Осалось рабочих дней</p>
      </div>
    </div>
  );
}

export default ServiceIndicators;
